import { AEMScenes } from '@as-react/common-types';
import { authReducer } from '../../authentication/reducers/AuthReducer';
import authenticationSaga from '../../authentication/sagas/AuthSaga';
import { authFormReducer } from '../../authForm/reducers/AuthFormReducer';
import authFormSaga from '../../authForm/sagas/AuthFormSaga';
import { basketReducer } from '../../basket/reducers/BasketReducer';
import basketSaga from '../../basket/sagas/BasketSagas';
import { compareReducer } from '../../compare/reducers/CompareReducer';
import compareSaga from '../../compare/sagas/CompareSagas';
import deliveryPromiseSaga from '../../deliveryPromise/sagas/DeliveryPromiseSaga';
import { productPreviewReducer } from '../../productPreview/reducers/ProductPreviewReducer';
import productPreviewSaga from '../../productPreview/sagas/ProductPreviewSaga';
import urlSaga from '../../url/sagas/UrlSagas';
import { wishListReducer } from '../../wishList/reducers/WishListReducer';
import wishListSaga from '../../wishList/sagas/WishListSaga';
import productRecentlyViewedSaga from '../../productRecentlyViewed/sagas/ProductRecentlyViewedSaga';
const loadProductDetailDynamicModule = () => ({
    id: AEMScenes.PRODUCT_DETAIL_V2,
    reducerMap: {
        authentication: authReducer,
        authForm: authFormReducer,
        basket: basketReducer,
        compare: compareReducer,
        productPreview: productPreviewReducer,
        wishList: wishListReducer,
    },
    sagas: [
        authenticationSaga,
        authFormSaga,
        basketSaga,
        compareSaga,
        deliveryPromiseSaga,
        productPreviewSaga,
        urlSaga,
        wishListSaga,
        productRecentlyViewedSaga,
    ],
});
export default loadProductDetailDynamicModule;
